import type { ReactNode } from "react";

type Props = {
  kicker?: string;
  headline?: ReactNode;
  lede?: ReactNode;
  sectionTitle?: string;
  children: ReactNode;
};

export function SignInCenteredLayout({
  kicker = "AI Flavor Discovery",
  headline = (
    <>
      Design a flavor in <em>minutes</em>, not months.
    </>
  ),
  lede = "N-OS compresses weeks of lab iteration into hours — so you can design and refine formulas without breaking the creative cycle.",
  sectionTitle = "Log in to access N-OS",
  children,
}: Props) {
  return (
    <div className="signin-centered">
      <div className="signin-centered-content">
        <header className="signin-centered-brand">
          <div className="signin-centered-brand-icon" aria-hidden>
            <img src="/logo-square.png" alt="Noah's Farm" />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="signin-centered-brand-sub">N-OS Platform</div>
          </div>
        </header>

        <main className="signin-centered-card">
          {kicker && <div className="signin-centered-kicker">{kicker}</div>}
          {headline && (
            <h1 className="signin-headline signin-centered-headline">
              {headline}
            </h1>
          )}
          {lede && <p className="signin-centered-lede">{lede}</p>}
          {(kicker || headline || lede) && <div className="signin-rule" />}
          {sectionTitle && (
            <div className="signin-section-title">{sectionTitle}</div>
          )}
          {children}
        </main>
      </div>

      <footer className="signin-centered-footer">
        <div>
          Don't have an account yet?{"  "}
          <a href="#">Contact us for a free trial account</a>
        </div>
        <div className="signin-centered-legal">
          <a href="#">Privacy</a>
          <span className="dot" />
          <a href="#">Terms</a>
          <span className="dot" />
          <a href="#">Security</a>
          <span className="dot" />
          <span>© 2026 Noah's Farm Inc.</span>
        </div>
      </footer>
    </div>
  );
}
